import { TReduxActions } from '../../actions';
import { EListingOffersActionType, ELoadListingActionTypes } from '../../actions/listingOffers';
import { EAddToFavoritesActionTypes } from '../../actions/newFavorites/addToFavorite';
import { ERemoveFromFavoritesActionTypes } from '../../actions/newFavorites/removeFromFavorite';
import { EFetchStatus, IListingOffersState } from '../../types/listingOffers';

const OFFERS_PER_PAGE = 28;

const defaultSeoSchemas = {
  mortgageDiscount: '',
  onlineShow: '',
  organizationInfo: '',
  product: '',
  wideSelection: '',
};

export const defaultState: IListingOffersState = {
  offers: [],
  page: 1,
  maxOffersCount: OFFERS_PER_PAGE,
  currentOffersCount: 0,
  status: EFetchStatus.INITIAL,
  mlRanking: null,
  seoData: {
    markedList: { items: [] },
    seoSchemas: defaultSeoSchemas,
  },
  breadcrumbs: null,
  hasMoreOffers: false,
  puids: null,
  sortVariants: [],
};

export function listingOffersReducer(
  state: IListingOffersState = defaultState,
  action: TReduxActions,
): IListingOffersState {
  switch (action.type) {
    case EListingOffersActionType.RemoveOffers: {
      return { ...state, maxOffersCount: OFFERS_PER_PAGE, currentOffersCount: 0, offers: [], mlRanking: null };
    }
    case EListingOffersActionType.MarkEmpty: {
      return {
        ...state,
        status: EFetchStatus.SUCCESS,
        maxOffersCount: OFFERS_PER_PAGE,
        currentOffersCount: 0,
        offers: [],
        mlRanking: null,
        hasMoreOffers: false,
      };
    }
    case EListingOffersActionType.SetPage: {
      return { ...state, page: action.payload };
    }
    case ELoadListingActionTypes.Request: {
      if (action.payload.reset) {
        return {
          ...state,
          status: EFetchStatus.LOADING,
          offers: [],
          currentOffersCount: 0,
          mlRanking: null,
        };
      }

      return { ...state, status: EFetchStatus.LOADING };
    }
    case ELoadListingActionTypes.Success: {
      return {
        ...state,
        status: EFetchStatus.SUCCESS,
        maxOffersCount: action.payload.offersCount,
        currentOffersCount: action.payload.offers.length,
        offers: action.payload.offers,
        mlRanking: action.payload.mlRanking,
        seoData: action.payload.seoData,
        breadcrumbs: action.payload.breadcrumbs,
        hasMoreOffers: action.payload.offersCount >= OFFERS_PER_PAGE,
        puids: action.payload.puids ?? state.puids,
        sortVariants: action.payload.sortVariants,
      };
    }
    case ELoadListingActionTypes.Failure: {
      return { ...defaultState, status: EFetchStatus.FAILURE };
    }

    case ERemoveFromFavoritesActionTypes.Success:
    case EAddToFavoritesActionTypes.Success: {
      const { offerId, isFavorite } = action.payload;

      const offerToChangeIdx = state.offers.findIndex(offer => offer.id === offerId);

      if (offerToChangeIdx === -1) {
        return state;
      }

      const offers = state.offers.slice();
      offers[offerToChangeIdx] = { ...offers[offerToChangeIdx], isFavorite };

      return { ...state, offers };
    }
  }

  return state;
}
